export default "__VITE_ASSET__bf7d53f5__"